import classNames from 'classnames';
import { PureComponent } from 'react';

import Typography from '@mui/material/Typography';

export default class PageBreakBlock extends PureComponent {
  render() {
    const { blockProps } = this.props;
    const { readOnly } = blockProps;

    return (
      <div className={classNames({ readOnly }, 'break-after')} css={rootCss}>
        <Typography variant="button">PAGE BREAK</Typography>
      </div>
    );
  }
}

const rootCss = ({ palette, spacing }) => ({
  border: `dashed ${palette.divider}`,
  borderWidth: '1px 0',
  padding: spacing(0.5, 0),
  margin: spacing(2, 0),
  textAlign: 'center',
  color: palette.text.secondary,

  '&.readOnly': {
    breakBefore: 'page',
    visibility: 'hidden',
    margin: 0,
    padding: 0,
  },
});
